import React from 'react';
import {Button, Divider, Input, message, Select, Table, Tag} from 'antd';
import copy from 'copy-to-clipboard';
import WebServerRestClient from '../../tools/WebServerRestClient';
import UserComponent from '../../components/UserComponent';
import CommonUtils from '../../tools/CommonUtils';

const {Option} = Select;

const handleStatusList = [
    {value: 1, label: 'PENDING', color: 'gold'},
    {value: 2, label: 'CONSUMED', color: 'green'},
    {value: 4, label: 'FAILED', color: 'red'}
];

export default class EthTransactionList extends UserComponent {

    constructor(props) {
        super(props);
        const searchParams = new URLSearchParams(props.location.search);
        this.state = {
            loading: false,
            dataList: [],
            totalCount: 0,
            totalPages: 0,
            currentPage: 1,
            pageSize: 10,
            query_params: {
                hash: searchParams.get('hash') || '',
                from: '',
                to: '',
                handleStatus: undefined
            }
        };
    }

    componentDidMount() {
        this.loadListData();
    }

    setQueryParam(name, value) {
        this.setState({
            query_params: Object.assign({}, this.state.query_params, {[name]: value})
        });
    }

    buildQueryParams(pagination) {
        const params = {
            currentPage: pagination.currentPage,
            pageSize: pagination.pageSize
        };
        ['hash', 'from', 'to'].forEach(name => {
            const value = this.state.query_params[name];
            if (value && value.trim()) {
                params[name] = value.trim();
            }
        });
        if (handleStatusList.some(status => status.value === this.state.query_params.handleStatus)) {
            params.handleStatus = this.state.query_params.handleStatus;
        }
        return params;
    }

    loadListData(changedParams) {
        const pagination = changedParams || {
            currentPage: 1,
            pageSize: this.state.pageSize
        };
        this.setState({loading: true});
        new WebServerRestClient().GET(
            '/admin/eth-transactions',
            this.buildQueryParams(pagination)
        ).then(response => {
            this.setState({loading: false});
            if (response.code === 200) {
                const data = response.data || {};
                this.setState({
                    dataList: data.rows || [],
                    totalCount: data.totalCount || 0,
                    totalPages: data.totalPages || 0,
                    currentPage: pagination.currentPage,
                    pageSize: data.pageSize || pagination.pageSize
                });
            } else if (response.code === 401 || response.code === 403) {
                this.props.history.push('/login');
            } else {
                message.error(this.getErrorMessage(response));
            }
        }).catch(err => {
            this.setState({loading: false});
            message.error('Error: ' + err.message);
        });
    }

    getErrorMessage(response) {
        return response.message || response.msg || 'Request failed';
    }

    copyText(value, label) {
        if (copy(String(value))) {
            message.success(label + ' copied.');
        } else {
            message.error('Unable to copy ' + label.toLowerCase() + '.');
        }
    }

    renderCopyableText(value, label) {
        const text = value === 0 || value ? String(value) : '';
        if (!text) {
            return '';
        }
        return (
            <span style={{display: 'flex', alignItems: 'center', whiteSpace: 'nowrap'}}>
                <span title={text}
                      style={{
                          display: 'inline-block',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          fontFamily: 'SFMono-Regular, Consolas, Liberation Mono, monospace',
                          flex: 1
                      }}>
                    {text}
                </span>
                <Button type="link"
                        size="small"
                        icon="copy"
                        title={'Copy ' + label}
                        aria-label={'Copy ' + label}
                        style={{height: 'auto', padding: '0 0 0 6px'}}
                        onClick={() => this.copyText(text, label)}/>
            </span>
        );
    }

    renderHandleStatus(value) {
        const status = handleStatusList.find(item => item.value === Number(value));
        if (!status) {
            return value;
        }
        return <Tag color={status.color}>{status.label}</Tag>;
    }

    renderAmount(value) {
        if (value === null || typeof value === 'undefined' || value === '') {
            return '';
        }
        const amount = CommonUtils.toDecimal(value, 6);
        return amount === false ? String(value) : amount;
    }

    renderTransactionTime(value) {
        if (value === null || typeof value === 'undefined' || value === '') {
            return '';
        }
        const timestamp = Number(value);
        if (!Number.isFinite(timestamp)) {
            return String(value);
        }
        return CommonUtils.formatDate(new Date(timestamp * 1000), 'yyyy-MM-dd hh:mm:ss');
    }

    render() {
        return (
            <div className="container">
                <div className="toolbar">
                    <Input placeholder="Hash"
                           className="search_input_middle"
                           value={this.state.query_params.hash}
                           onPressEnter={() => this.loadListData({currentPage: 1, pageSize: this.state.pageSize})}
                           onChange={(event) => this.setQueryParam('hash', event.target.value)}/>
                    <Divider type="vertical"/>
                    <Input placeholder="From"
                           className="search_input_middle"
                           value={this.state.query_params.from}
                           onPressEnter={() => this.loadListData({currentPage: 1, pageSize: this.state.pageSize})}
                           onChange={(event) => this.setQueryParam('from', event.target.value)}/>
                    <Divider type="vertical"/>
                    <Input placeholder="To"
                           className="search_input_middle"
                           value={this.state.query_params.to}
                           onPressEnter={() => this.loadListData({currentPage: 1, pageSize: this.state.pageSize})}
                           onChange={(event) => this.setQueryParam('to', event.target.value)}/>
                    <Divider type="vertical"/>
                    <Select style={{width: 160}}
                            placeholder="Handle Status"
                            allowClear={true}
                            value={this.state.query_params.handleStatus}
                            onChange={(value) => this.setQueryParam('handleStatus', value)}>
                        {handleStatusList.map(status => (
                            <Option key={status.value} value={status.value}>{status.label}</Option>
                        ))}
                    </Select>
                    <Divider type="vertical"/>
                    <Button type="primary"
                            icon="search"
                            className="search_btn"
                            loading={this.state.loading}
                            onClick={() => this.loadListData({currentPage: 1, pageSize: this.state.pageSize})}>
                        Search
                    </Button>
                </div>

                <Table loading={this.state.loading}
                       rowKey={record => record.id}
                       dataSource={this.state.dataList}
                       scroll={{x: 1500}}
                       columns={[
                           {
                               title: 'Hash',
                               dataIndex: 'hash',
                               width: 300,
                               render: value => this.renderCopyableText(value, 'Hash')
                           },
                           {title: 'Blockchain', dataIndex: 'blockchain', align: 'center', width: 110},
                           {title: 'Currency', dataIndex: 'currency', align: 'center', width: 100},
                           {
                               title: 'Amount',
                               dataIndex: 'amount',
                               align: 'right',
                               width: 130,
                               render: value => this.renderAmount(value)
                           },
                           {
                               title: 'From',
                               dataIndex: 'from',
                               width: 300,
                               render: value => this.renderCopyableText(value, 'From')
                           },
                           {
                               title: 'To',
                               dataIndex: 'to',
                               width: 300,
                               render: value => this.renderCopyableText(value, 'To')
                           },
                           {
                               title: 'Handle Status',
                               dataIndex: 'handleStatus',
                               align: 'center',
                               width: 140,
                               render: value => this.renderHandleStatus(value)
                           },
                           {
                               title: 'Transaction Time',
                               dataIndex: 'timeStamp',
                               align: 'center',
                               width: 170,
                               render: value => (
                                   <span style={{whiteSpace: 'nowrap'}}>{this.renderTransactionTime(value)}</span>
                               )
                           }
                       ]}
                       pagination={{
                           current: this.state.currentPage,
                           pageSize: this.state.pageSize,
                           total: this.state.totalCount,
                           onChange: (currentPage, pageSize) => {
                               this.loadListData({currentPage, pageSize});
                           },
                           showTotal: total => `total of ${total} records`,
                           className: 'pagination'
                       }}/>
            </div>
        );
    }
}
